import { WorkFlowTaskInfo } from './work-flow-task-info.model';
export class WorkFlowTaskReturnInfo {
  flowId?: number;
  userId?: number;
  flowTasks?: Array<WorkFlowTaskInfo> = [];
}
